<div *ngIf="config?.gallery_items.length > 0">
  <div>
    <div #galleryContainer class="gallery-container">
      <mat-card
        class="gallery-card"
        [ngStyle]="{
          border: '1px solid ' + configs?.colors?.bot_message_border,
          background: configs?.colors?.bot_message_background,
          'font-size': '14px'
        }"
        *ngFor="let item of config.gallery_items; let i = index"
      >
        <ng-container *ngIf="item.image_url">
          <a
            [href]="item.image_url"
            target="_blank"
            [ngStyle]="{ 'margin-bottom': '10px' }"
          >
            <img
              mat-card-image
              [src]="item.image_url"
              [alt]="item.title"
              class="gallery-media"
            />
          </a>
        </ng-container>
        <ng-container
          *ngIf="item.video_url"
          [ngStyle]="{ 'margin-bottom': '10px' }"
        >
          <ng-container
            *ngIf="isYouTubeVideo(item.video_url); else standardVideo"
          >
            <iframe
              [src]="getYouTubeEmbedUrl(item.video_url)"
              frameborder="0"
              allowfullscreen
              class="gallery-media"
            ></iframe>
          </ng-container>
          <ng-template #standardVideo>
            <video
              [src]="item.video_url"
              controls
              class="gallery-media"
            ></video>
          </ng-template>
        </ng-container>

        <mat-card-header>
          <mat-card-title
            [ngStyle]="{
          'font-family': configs?.fonts?.default_font,
          'font-size': '16px',
          color: configs?.colors?.bot_message_text,
          'font-weight':'500',
          'text-overflow': 'initial',
          'white-space': 'pre-wrap',
        }"
            [innerHTML]="item.title"
          >
          </mat-card-title>
          <mat-card-subtitle
            [ngStyle]="{
              'font-family': configs?.fonts?.default_font,
              'font-size': '14px',
              color: configs?.colors?.bot_message_text,
              'font-weight': '400',
              'margin-bottom': '10px',
              'word-break': 'break-word',
              'line-height': '20px',
            }"
            [innerHTML]="item.sub_title"
          ></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content> </mat-card-content>
        <div align="start">
          <div class="gallery-item">
            <div class="gallery-buttons" *ngIf="item.buttons_config?.active">
              <button
                *ngFor="let button of item.buttons_config.buttons"
                mat-stroked-button
                (click)="onGalleryButtonClick(item, button)"
                [ngStyle]="{
                'background-color': configs?.colors?.bot_message_button_background,
                color: configs?.colors?.bot_message_text,
                border: '1px solid ' + configs?.colors?.bot_message_border,
                'font-size': '16px',
                'font-weight':'400',
                'font-family': configs?.fonts?.default_font,
              }"
              >
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="display-flex flex-space-between" style="width: 100%">
      <app-message-timestamp
        *ngIf="input.created_at && input.created_at > 0"
        [createdAt]="input.created_at"
      >
      </app-message-timestamp>
      <span
        class="unread"
        *ngIf="!isRead"
        [ngStyle]="{
                'color': configs?.colors?.user_message_background,
              }"
        >{{ messageUnreadText }}</span
      >
    </div>
  </div>
</div>
